import React, { useEffect, useState} from 'react';
const LanguageBtn = ({getLanguage}) => {
  const [savedLanguage, setSavedLanguage] = useState(0);

  const handleLanguageChange = (event) => {
    let val = event.target.value;
    let landICO = land[country.indexOf(val)];
    setSavedLanguage(event.target.value);
    localStorage.setItem('choosen-language', JSON.stringify(landICO));
    getLanguage(landICO);
  };

  const country = ['English', 'Français'];
  const land = ['eng', 'fra'];
  
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('choosen-language'));
    if(data === null) {
      localStorage.setItem('choosen-language', JSON.stringify('eng'));
      setSavedLanguage(country[0]);
    }else{
      setSavedLanguage(country[land.indexOf(data)]);
    }
  }, [])

    return <div className="flex items-center gap-2">
        <select
          value={savedLanguage}
          onChange={handleLanguageChange}
        >
          {country.map(value => (
            <option value={value}>{value}</option>
          ))}
        </select>
    </div>
}

export default LanguageBtn;